import React, { CSSProperties, ReactElement } from "react";

interface ISubscriptionIconsProps {
	icon: "webinar" | "support" | "charges" | "commission" | "platforms" | "research" | "platinum_knot" | "gold_knot" | "black_knot" | "blue_knot";
	width: string;
	height: string;
	style?: CSSProperties;
}

export default function SubscriptionIcons(props: ISubscriptionIconsProps): ReactElement {
	let returnSvg: ReactElement = <>No Icon</>;

	switch (props.icon) {
		case "webinar":
			returnSvg = (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={props.width}
					height={props.height}
					viewBox={"0 0 " + props.width + " " + props.height}
					style={props.style || {}}
				>
					<g>
						<path
							fill="#174082"
							d="M-24.522-1.08a1.054 1.054 0 0 0-1.7.826v9.766a1.056 1.056 0 0 0 1.645.879l7.462-4.832a1.1 1.1 0 0 0 0-1.808zm.436 8.618V1.721l4.445 2.907z"
							transform="translate(39.091 8.281)"
						/>
						<path
							fill="#fc3f00"
							d="M-.518-2.95h-25.417A3.5 3.5 0 0 0-29.427.542V19.76a3.493 3.493 0 0 0 3.492 3.489h8.068a6.1 6.1 0 0 1-1.7 1.812 1.084 1.084 0 0 0-.389 1.231 1.07 1.07 0 0 0 1.027.759h11.4a1.08 1.08 0 0 0 1.038-.8 1.074 1.074 0 0 0-.427-1.219 6.1 6.1 0 0 1-1.661-1.786h8.061a3.493 3.493 0 0 0 3.492-3.486V.542A3.5 3.5 0 0 0-.518-2.95zm-10.432 26.2a5.47 5.47 0 0 0 .759 1.589h-6.082a5.251 5.251 0 0 0 .774-1.589zM-25.935-.738H-.518A1.267 1.267 0 0 1 .762.542v18.47c0 .344-.023.959-.057 1.152a1.215 1.215 0 0 1-1.223.876h-25.417a1.3 1.3 0 0 1-1.284-.861V.542a1.268 1.268 0 0 1 1.284-1.28z"
							transform="translate(29.427 2.95)"
						/>
					</g>
				</svg>
			);
			break;
		case "support":
			returnSvg = (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={props.width}
					height={props.height}
					viewBox={"0 0 " + props.width + " " + props.height}
					style={props.style || {}}
				>
					<path
						fill="#fc3f00"
						d="M56.4 42.08a5.4 5.4 0 0 0-2.876-4.766 12.05 12.05 0 0 0-24.058-.126 5.392 5.392 0 0 0 2.124 10.349 1.556 1.556 0 0 0 .312-.029 1.214 1.214 0 0 0 .26.029 1.286 1.286 0 0 0 1.269-1.269v-8.185a1.286 1.286 0 0 0-.871-1.2 1.411 1.411 0 0 0-.461-.136h-.045a9.521 9.521 0 0 1 18.865-.047c-.082.006-.164.013-.247.027a1.732 1.732 0 0 1-.272.03 1.219 1.219 0 0 0-.523.2 1.283 1.283 0 0 0-.707 1.128v8.185a1.279 1.279 0 0 0 .668 1.105 5.084 5.084 0 0 1-1.158 3.252 5.316 5.316 0 0 1-3.989 1.49 3.306 3.306 0 1 0-.786 2.528h.443a8.3 8.3 0 0 0 6.267-2.266 7.877 7.877 0 0 0 1.775-5.028 5.45 5.45 0 0 0 4.01-5.271zm-4.7-2.715a2.849 2.849 0 0 1 0 5.557zm-20.8-.044v5.518a2.843 2.843 0 0 1 0-5.518zm11.294 13.1a.761.761 0 1 1-1.523 0 .761.761 0 0 1 1.523 0z"
						transform="translate(-26.2 -25.9)"
					/>
					<path
						fill="#174082"
						d="M48.234 64.958a.876.876 0 1 1-.876.876.877.877 0 0 1 .876-.876m0-2.538a3.414 3.414 0 1 0 3.414 3.414 3.414 3.414 0 0 0-3.414-3.414z"
						transform="translate(-33.005 -39.247)"
					/>
				</svg>
			);
			break;
		case "charges":
			returnSvg = (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={props.width}
					height={props.height}
					viewBox={"0 0 " + props.width + " " + props.height}
					style={props.style || {}}
				>
					<g>
						<path
							fill="#fc3f00"
							d="M25.33 42.872a1.425 1.425 0 0 0-1.371 1 1.386 1.386 0 0 0 .573 1.562L38.1 54.292a1.468 1.468 0 0 0 1.591 0l13.57-8.859a1.386 1.386 0 0 0 .574-1.566 1.421 1.421 0 0 0-1.361-1h-2.488v-.227l-.076-17.368a2.221 2.221 0 0 0-2.146-2.233H29.885a2.219 2.219 0 0 0-2.145 2.23l.076 17.371v.233H25.33zm4.806 2.488a1.393 1.393 0 0 0 .537-1.095l-.079-18.2v-.233h16.451v.231l.076 18.206a1.391 1.391 0 0 0 .539 1.094l.258.2-.273.178-8.619 5.626-.127.084-.127-.084-8.621-5.628-.273-.178z"
							transform="translate(-23.9 -23.038)"
						/>
						<path
							fill="#174082"
							d="M43.526 33.981h-1.7v-1.37h1.7a.753.753 0 0 0 0-1.5h-7.243a.753.753 0 0 0 0 1.5h4.084v1.37h-4.085a.753.753 0 0 0 0 1.5h3.842a3.4 3.4 0 0 1-.268.452 3.355 3.355 0 0 1-.447.465 3.236 3.236 0 0 1-.55.331 3.2 3.2 0 0 1-.622.175 9.122 9.122 0 0 1-.929.019h-1.027a.749.749 0 0 0-.731.752v.112a.775.775 0 0 0 .216.54l.023.024.124.129.508.531 1.645 1.717 1.7 1.773.812.848a.722.722 0 0 0 1.021.012l.012-.012a.776.776 0 0 0 0-1.064l-.771-.8-1.687-1.76-1.237-1.293c.079 0 .159-.006.238-.012a3.84 3.84 0 0 0 1.957-.694 4.018 4.018 0 0 0 1.323-1.58 4.609 4.609 0 0 0 .244-.657h1.846a.753.753 0 0 0 0-1.5z"
							transform="translate(-24.722 -23.608)"
						/>
					</g>
				</svg>
			);
			break;
		case "commission":
			returnSvg = (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					id="Component_12_1"
					width={props.width}
					height={props.height}
					viewBox={"0 0 " + props.width + " " + props.height}
					style={props.style || {}}
				>
					<defs></defs>
					<g id="Component_49_1">
						<path
							id="Path_1437"
							fill="#fc3f00"
							d="M44.994 30.4a4.158 4.158 0 0 1-.761-.8 2.9 2.9 0 0 1 .257-1.085 3.577 3.577 0 0 0 .085-2.976 3.794 3.794 0 0 0-2.685-1.415 3.022 3.022 0 0 1-1.063-.281 3.7 3.7 0 0 1-.211-.735c-.029-.128-.058-.257-.083-.354l-.012-.063a3.463 3.463 0 0 0-1.433-2.623 3.947 3.947 0 0 0-2.994.1 2.8 2.8 0 0 1-1.077.255 4.241 4.241 0 0 1-.806-.772l-.071-.075a3.588 3.588 0 0 0-2.545-1.515 3.648 3.648 0 0 0-2.625 1.6 4.009 4.009 0 0 1-.8.764 3.266 3.266 0 0 1-1.076-.261 3.853 3.853 0 0 0-3.02-.085 3.793 3.793 0 0 0-1.415 2.685 2.964 2.964 0 0 1-.282 1.063 3.7 3.7 0 0 1-.739.213c-.127.028-.254.057-.35.081l-.063.013a3.463 3.463 0 0 0-2.6 1.4 3.489 3.489 0 0 0 .064 2.91l.026.08a2.892 2.892 0 0 1 .253 1.07 4.174 4.174 0 0 1-.772.806l-.075.07a3.589 3.589 0 0 0-1.515 2.545 3.646 3.646 0 0 0 1.6 2.625 4.2 4.2 0 0 1 .761.8 2.9 2.9 0 0 1-.267 1.09 3.578 3.578 0 0 0-.084 2.975A3.8 3.8 0 0 0 21.3 41.92a2.987 2.987 0 0 1 1.063.281 3.821 3.821 0 0 1 .213.746c.028.125.056.249.081.344l.013.064a3.456 3.456 0 0 0 1.43 2.622 3.93 3.93 0 0 0 2.988-.1 2.886 2.886 0 0 1 1.083-.257 4.171 4.171 0 0 1 .806.772l.07.075a3.589 3.589 0 0 0 2.545 1.515 3.592 3.592 0 0 0 2.546-1.515l.079-.085a4.007 4.007 0 0 1 .805-.766 3.178 3.178 0 0 1 1.077.261 3.849 3.849 0 0 0 3.02.084 3.791 3.791 0 0 0 1.415-2.685 3.049 3.049 0 0 1 .281-1.062 3.724 3.724 0 0 1 .75-.215c.123-.028.247-.055.34-.079l.063-.013a3.462 3.462 0 0 0 2.6-1.4 3.486 3.486 0 0 0-.064-2.911l-.025-.079a2.877 2.877 0 0 1-.253-1.071 4.153 4.153 0 0 1 .772-.806l.075-.071a3.588 3.588 0 0 0 1.515-2.545 3.649 3.649 0 0 0-1.594-2.624zm-2.826 7.787l.017.052c.024.1.051.2.08.3.039.149.151.565.174.732a6.736 6.736 0 0 1-.85.233l-.247.056a4.47 4.47 0 0 0-2.235.973 4.026 4.026 0 0 0-.941 2.1l-.079.344a8.818 8.818 0 0 1-.235.884 3.365 3.365 0 0 1-.768-.193l-.278-.087A5.861 5.861 0 0 0 35 43.2a2.688 2.688 0 0 0-.673.063 4.1 4.1 0 0 0-1.95 1.492 5.555 5.555 0 0 1-.772.769 4.85 4.85 0 0 1-.773-.758 4.13 4.13 0 0 0-1.972-1.506 2.685 2.685 0 0 0-.666-.061 6.139 6.139 0 0 0-1.449.237l-.047.012-.324.079-.065.021a3.532 3.532 0 0 1-1.012.267 6.9 6.9 0 0 1-.23-.844l-.055-.243a4.478 4.478 0 0 0-.973-2.239 4.033 4.033 0 0 0-2.1-.942l-.338-.077a5.956 5.956 0 0 1-.885-.247 6 6 0 0 1 .27-.972 4.205 4.205 0 0 0 .326-2.5A4.091 4.091 0 0 0 19.82 33.8a5.739 5.739 0 0 1-.77-.773 4.915 4.915 0 0 1 .758-.773 4.128 4.128 0 0 0 1.5-1.96 4.4 4.4 0 0 0-.29-2.391l-.018-.05c-.023-.093-.049-.191-.079-.3-.04-.15-.151-.568-.175-.736a6.779 6.779 0 0 1 .852-.233l.241-.055a4.47 4.47 0 0 0 2.239-.974 4.025 4.025 0 0 0 .941-2.1l.078-.337a8.879 8.879 0 0 1 .236-.89 3.241 3.241 0 0 1 .746.186c.1.033.211.067.3.094a5.842 5.842 0 0 0 1.81.382 2.668 2.668 0 0 0 .674-.063 4.1 4.1 0 0 0 1.949-1.49 3.845 3.845 0 0 1 .81-.732 4.719 4.719 0 0 1 .78.762 4.129 4.129 0 0 0 1.968 1.506 2.678 2.678 0 0 0 .665.061 5.948 5.948 0 0 0 1.84-.393 3.561 3.561 0 0 1 1.013-.268 7.049 7.049 0 0 1 .23.846l.055.239a4.475 4.475 0 0 0 .974 2.241 4.031 4.031 0 0 0 2.1.941l.337.077a6 6 0 0 1 .888.247 5.9 5.9 0 0 1-.27.973 4.214 4.214 0 0 0-.326 2.5 4.094 4.094 0 0 0 1.491 1.948 5.575 5.575 0 0 1 .77.774 4.838 4.838 0 0 1-.758.773 4.132 4.132 0 0 0-1.5 1.96 4.394 4.394 0 0 0 .29 2.393z"
							transform="translate(-16.595 -18.067)"
						/>
						<path id="Rectangle_982" d="M0 0H11.316V2.438H0z" fill="#174082" transform="rotate(-45 26.927 -3.194)" />
						<path
							id="Path_1438"
							d="M35.519 33.475A2.721 2.721 0 1 0 32.8 36.2a2.724 2.724 0 0 0 2.719-2.725zm-3.445-.045a.725.725 0 1 1 .724.724.744.744 0 0 1-.725-.723z"
							fill="#174082"
							transform="translate(-21.084 -22.292)"
						/>
						<path
							id="Path_1439"
							d="M43.248 41.072a2.721 2.721 0 1 0 2.721 2.721 2.724 2.724 0 0 0-2.721-2.721zm0 3.445a.725.725 0 1 1 .724-.724.744.744 0 0 1-.724.724z"
							fill="#174082"
							transform="translate(-24.564 -25.727)"
						/>
					</g>
				</svg>
			);
			break;
		case "platforms":
			returnSvg = (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					id="Component_12_1"
					width={props.width}
					height={props.height}
					viewBox={"0 0 " + props.width + " " + props.height}
					style={props.style || {}}
				>
					<defs></defs>
					<path
						id="Union_3"
						d="M-1049.9-20990.3a.757.757 0 0 1-.706-.762v-4.639l-.471.49c-.289.307-.582.607-.876.912a.72.72 0 0 1-1.033 0 .79.79 0 0 1 0-1.074l.322-.336 1.4-1.455.876-.912a.716.716 0 0 1 .429-.215c.029 0 .058-.008.088-.01a.644.644 0 0 1 .422.143.626.626 0 0 1 .095.082c.108.117.215.225.322.338q.694.727 1.4 1.451l.876.914a.794.794 0 0 1 0 1.074.657.657 0 0 1-.5.221.724.724 0 0 1-.529-.221l-.322-.334c-.343-.355-.683-.709-1.024-1.068v4.639a.759.759 0 0 1-.731.762z"
						fill="#174082"
						transform="translate(1060.303 21004.672)"
					/>
					<path
						id="Union_4"
						d="M-1049.9-20990.3a.757.757 0 0 1-.706-.762v-4.639l-.471.49c-.289.307-.582.607-.876.912a.72.72 0 0 1-1.033 0 .79.79 0 0 1 0-1.074l.322-.336 1.4-1.455.876-.912a.716.716 0 0 1 .429-.215c.029 0 .058-.008.088-.01a.644.644 0 0 1 .422.143.626.626 0 0 1 .095.082c.108.117.215.225.322.338q.694.727 1.4 1.451l.876.914a.794.794 0 0 1 0 1.074.657.657 0 0 1-.5.221.724.724 0 0 1-.529-.221l-.322-.334c-.343-.355-.683-.709-1.024-1.068v4.639a.759.759 0 0 1-.731.762z"
						fill="#174082"
						transform="rotate(180 -515.728 -10491.965)"
					/>
					<g id="Group_4238">
						<g id="Group_4237">
							<path
								id="Path_1677"
								d="M78.227 100.846h2.416a3.1 3.1 0 0 1 .413.009c-.095-.012-.19-.024-.285-.04a1 1 0 0 1 .193.055c-.086-.037-.171-.073-.257-.107a.847.847 0 0 1 .168.1c-.073-.055-.144-.11-.217-.168a.977.977 0 0 1 .138.138c-.055-.073-.11-.144-.168-.217a1.067 1.067 0 0 1 .1.168c-.037-.086-.073-.171-.107-.257a1.065 1.065 0 0 1 .055.193c-.012-.095-.024-.19-.04-.285a4.469 4.469 0 0 1 .009.573v14.935c0 .695.006 1.39 0 2.088a1.185 1.185 0 0 1-.009.147c.012-.095.024-.19.04-.285a1 1 0 0 1-.055.193c.037-.086.073-.171.107-.257a.847.847 0 0 1-.1.168c.055-.073.11-.144.168-.217a.976.976 0 0 1-.138.138c.073-.055.144-.11.217-.168a1.067 1.067 0 0 1-.168.1c.086-.037.171-.073.257-.107a1.066 1.066 0 0 1-.193.055c.095-.012.19-.024.285-.04a5.577 5.577 0 0 1-.75.009H56.698a1.428 1.428 0 0 1-.159-.009c.095.012.19.024.285.04a1 1 0 0 1-.193-.055c.086.037.171.073.257.107a.847.847 0 0 1-.168-.1c.073.055.144.11.217.168a.977.977 0 0 1-.138-.138c.055.073.11.144.168.217a1.066 1.066 0 0 1-.1-.168c.037.086.073.171.107.257a1.066 1.066 0 0 1-.055-.193c.012.095.024.19.04.285a4.468 4.468 0 0 1-.009-.573v-14.934c0-.695-.006-1.39 0-2.088a1.184 1.184 0 0 1 .009-.147c-.012.095-.024.19-.04.285a1 1 0 0 1 .055-.193c-.037.086-.073.171-.107.257a.847.847 0 0 1 .1-.168c-.055.073-.11.144-.168.217a.976.976 0 0 1 .138-.138c-.073.055-.144.11-.217.168a1.066 1.066 0 0 1 .168-.1c-.086.037-.171.073-.257.107a1.066 1.066 0 0 1 .193-.055c-.095.012-.19.024-.285.04a7.651 7.651 0 0 1 .955-.009H78.227a1.072 1.072 0 1 0 0-2.143H56.845a2.908 2.908 0 0 0-.609.052 1.875 1.875 0 0 0-1.365 1.3 2.342 2.342 0 0 0-.07.652v17.262a2.033 2.033 0 0 0 .481 1.335 1.878 1.878 0 0 0 1.433.622h24.2a1.884 1.884 0 0 0 1.837-1.457 5.836 5.836 0 0 0 .049-1.059v-16.767a1.943 1.943 0 0 0-.548-1.4 1.924 1.924 0 0 0-1.341-.548h-2.685a1.073 1.073 0 0 0 0 2.146z"
								fill="#fc3f00"
								transform="translate(-54.8 -98.7)"
							/>
						</g>
					</g>
					<g id="Group_4240" transform="translate(10.538 19.086)">
						<g id="Group_4239">
							<path
								id="Path_1678"
								d="M404.848 726.175h-4.776l1.072 1.072v-4.075l-1.072 1.072h4.776l-1.072-1.072v4.075a1.072 1.072 0 1 0 2.143 0v-4.075a1.087 1.087 0 0 0-1.072-1.072h-4.776a1.087 1.087 0 0 0-1.071 1.072v4.075a1.087 1.087 0 0 0 1.072 1.072h4.776a1.072 1.072 0 1 0 0-2.143z"
								fill="#fc3f00"
								transform="translate(-399 -722.1)"
							/>
						</g>
					</g>
					<g id="Group_4242" transform="translate(7.831 23.161)">
						<g id="Group_4241">
							<path
								id="Path_1679"
								d="M311.646 857.343h10.189a1.072 1.072 0 1 0 0-2.143h-10.189a1.072 1.072 0 1 0 0 2.143z"
								fill="#fc3f00"
								transform="translate(-310.574 -855.2)"
							/>
						</g>
					</g>
				</svg>
			);
			break;
		case "research":
			returnSvg = (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={props.width}
					height={props.height}
					viewBox={"0 0 " + props.width + " " + props.height}
					style={props.style || {}}
				>
					<g>
						<path
							fill="#fc3f00"
							stroke="#fc3f00"
							strokeWidth="0.5px"
							d="M22.188 34.376a12.112 12.112 0 0 0 6.393-1.817l6.619 6.619a2.812 2.812 0 0 0 3.978-3.978l-6.619-6.619a12.184 12.184 0 1 0-10.371 5.795zm15.664 2.15a.939.939 0 0 1 0 1.326.961.961 0 0 1-1.326 0l-6.414-6.414a12.3 12.3 0 0 0 1.326-1.326zM22.188 11.875a10.313 10.313 0 1 1-10.313 10.313 10.324 10.324 0 0 1 10.313-10.313z"
							transform="translate(.25 .25) translate(-10 -10)"
						/>
						<path
							fill="#174082"
							d="M18.4 11.272l-2.863 2.863a.928.928 0 0 1-1.312 0l-1.087-1.088a2.788 2.788 0 0 0-3.936 0l-1.93 1.936a.928.928 0 1 0 1.312 1.312l1.935-1.935a.928.928 0 0 1 1.312 0l1.087 1.088a2.788 2.788 0 0 0 3.936 0l2.863-2.863a.928.928 0 1 0-1.317-1.313z"
							transform="translate(.25 .25) translate(-1.026 -1.567)"
						/>
					</g>
				</svg>
			);
			break;
		case "platinum_knot":
			returnSvg = (
				<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox={"0 0 " + props.width + " " + props.height}>
					<defs>
						<linearGradient id="hq1jury8va" x1=".5" x2=".5" y1="1" gradientUnits="objectBoundingBox">
							<stop offset="0" stopColor="#7c7c7c" />
							<stop offset="1" stopColor="#d6d6d6" />
						</linearGradient>
					</defs>
					<path
						fill="url(#hq1jury8va)"
						d="M136.089 20.13a9.736 9.736 0 0 0-4.9 1.317l-7.642 4.44-5.722-5.758 2.592-2.608a10.325 10.325 0 0 0 0-14.52 10.172 10.172 0 0 0-14.431 0l-2.586 2.61L100.8 3a10.172 10.172 0 0 0-14.426 0 10.325 10.325 0 0 0 0 14.52l2.592 2.609-5.722 5.758-7.636-4.437a9.748 9.748 0 0 0-4.9-1.32 9.869 9.869 0 0 0 0 19.737 9.736 9.736 0 0 0 4.9-1.317l7.642-4.44 5.722 5.758-2.592 2.609a10.325 10.325 0 0 0 0 14.52A10.168 10.168 0 0 0 100.8 57l2.592-2.609L105.989 57a10.168 10.168 0 0 0 14.431 0 10.325 10.325 0 0 0 0-14.52l-2.592-2.609 5.722-5.758 7.636 4.437a9.748 9.748 0 0 0 4.9 1.32 9.869 9.869 0 0 0 0-19.737zM72.327 32.855a2.9 2.9 0 0 1-1.61.384A3.417 3.417 0 0 1 67.436 30a3.284 3.284 0 0 1 3.269-3.29 3.238 3.238 0 0 1 1.628.437L77.243 30zm38.286-25.2a3.653 3.653 0 0 1 5.185 0 3.707 3.707 0 0 1 0 5.217l-2.598 2.607-5.185-5.217zm-7.215 7.26l5.185 5.217-5.183 5.215-5.188-5.217zM91 7.654a3.653 3.653 0 0 1 5.185 0l2.592 2.609-5.187 5.216L91 12.871a3.707 3.707 0 0 1 0-5.217zM88.4 30l5.185-5.217L98.774 30l-5.185 5.217zm7.777 22.346a3.653 3.653 0 0 1-5.185 0 3.707 3.707 0 0 1 0-5.217l2.593-2.609 5.185 5.217zm7.215-7.26l-5.185-5.217 5.185-5.217 5.185 5.217zm12.4 7.26a3.653 3.653 0 0 1-5.185 0l-2.592-2.609 5.185-5.217 2.592 2.609a3.707 3.707 0 0 1 .008 5.216zm-2.592-17.13L108.02 30l5.185-5.217L118.389 30zm22.885-1.972a2.951 2.951 0 0 1-1.628-.392L129.551 30l4.917-2.856A3.382 3.382 0 0 1 139.359 30a3.4 3.4 0 0 1-3.27 3.244z"
						transform="translate(-60.897)"
					/>
				</svg>
			);

			break;
		case "gold_knot":
			returnSvg = (
				<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox={"0 0 " + props.width + " " + props.height}>
					<defs>
						<linearGradient id="3fpsree7la" x1=".5" x2=".5" y1="1" gradientUnits="objectBoundingBox">
							<stop offset="0" stopColor="#fff5c1" />
							<stop offset="1" stopColor="#ffef6e" />
						</linearGradient>
					</defs>
					<path
						fill="url(#3fpsree7la)"
						d="M136.089 20.13a9.736 9.736 0 0 0-4.9 1.317l-7.642 4.44-5.722-5.758 2.592-2.608a10.325 10.325 0 0 0 0-14.52 10.172 10.172 0 0 0-14.431 0l-2.586 2.61L100.8 3a10.172 10.172 0 0 0-14.426 0 10.325 10.325 0 0 0 0 14.52l2.592 2.609-5.722 5.758-7.636-4.437a9.748 9.748 0 0 0-4.9-1.32 9.869 9.869 0 0 0 0 19.737 9.736 9.736 0 0 0 4.9-1.317l7.642-4.44 5.722 5.758-2.592 2.609a10.325 10.325 0 0 0 0 14.52A10.168 10.168 0 0 0 100.8 57l2.592-2.609L105.989 57a10.168 10.168 0 0 0 14.431 0 10.325 10.325 0 0 0 0-14.52l-2.592-2.609 5.722-5.758 7.636 4.437a9.748 9.748 0 0 0 4.9 1.32 9.869 9.869 0 0 0 0-19.737zM72.327 32.855a2.9 2.9 0 0 1-1.61.384A3.417 3.417 0 0 1 67.436 30a3.284 3.284 0 0 1 3.269-3.29 3.238 3.238 0 0 1 1.628.437L77.243 30zm38.286-25.2a3.653 3.653 0 0 1 5.185 0 3.707 3.707 0 0 1 0 5.217l-2.598 2.607-5.185-5.217zm-7.215 7.26l5.185 5.217-5.183 5.215-5.188-5.217zM91 7.654a3.653 3.653 0 0 1 5.185 0l2.592 2.609-5.187 5.216L91 12.871a3.707 3.707 0 0 1 0-5.217zM88.4 30l5.185-5.217L98.774 30l-5.185 5.217zm7.777 22.346a3.653 3.653 0 0 1-5.185 0 3.707 3.707 0 0 1 0-5.217l2.593-2.609 5.185 5.217zm7.215-7.26l-5.185-5.217 5.185-5.217 5.185 5.217zm12.4 7.26a3.653 3.653 0 0 1-5.185 0l-2.592-2.609 5.185-5.217 2.592 2.609a3.707 3.707 0 0 1 .008 5.216zm-2.592-17.13L108.02 30l5.185-5.217L118.389 30zm22.885-1.972a2.951 2.951 0 0 1-1.628-.392L129.551 30l4.917-2.856A3.382 3.382 0 0 1 139.359 30a3.4 3.4 0 0 1-3.27 3.244z"
						transform="translate(-60.897)"
					/>
				</svg>
			);
			break;
		case "black_knot":
			returnSvg = (
				<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox={"0 0 " + props.width + " " + props.height}>
					<defs>
						<linearGradient id="niggednw0a" x1=".5" x2=".5" y1="1" gradientUnits="objectBoundingBox">
							<stop offset="0" stopColor="#333" />
							<stop offset="1" stopColor="#535353" />
						</linearGradient>
					</defs>
					<path
						fill="url(#niggednw0a)"
						d="M136.089 20.13a9.736 9.736 0 0 0-4.9 1.317l-7.642 4.44-5.722-5.758 2.592-2.608a10.325 10.325 0 0 0 0-14.52 10.172 10.172 0 0 0-14.431 0l-2.586 2.61L100.8 3a10.172 10.172 0 0 0-14.426 0 10.325 10.325 0 0 0 0 14.52l2.592 2.609-5.722 5.758-7.636-4.437a9.748 9.748 0 0 0-4.9-1.32 9.869 9.869 0 0 0 0 19.737 9.736 9.736 0 0 0 4.9-1.317l7.642-4.44 5.722 5.758-2.592 2.609a10.325 10.325 0 0 0 0 14.52A10.168 10.168 0 0 0 100.8 57l2.592-2.609L105.989 57a10.168 10.168 0 0 0 14.431 0 10.325 10.325 0 0 0 0-14.52l-2.592-2.609 5.722-5.758 7.636 4.437a9.748 9.748 0 0 0 4.9 1.32 9.869 9.869 0 0 0 0-19.737zM72.327 32.855a2.9 2.9 0 0 1-1.61.384A3.417 3.417 0 0 1 67.436 30a3.284 3.284 0 0 1 3.269-3.29 3.238 3.238 0 0 1 1.628.437L77.243 30zm38.286-25.2a3.653 3.653 0 0 1 5.185 0 3.707 3.707 0 0 1 0 5.217l-2.598 2.607-5.185-5.217zm-7.215 7.26l5.185 5.217-5.183 5.215-5.188-5.217zM91 7.654a3.653 3.653 0 0 1 5.185 0l2.592 2.609-5.187 5.216L91 12.871a3.707 3.707 0 0 1 0-5.217zM88.4 30l5.185-5.217L98.774 30l-5.185 5.217zm7.777 22.346a3.653 3.653 0 0 1-5.185 0 3.707 3.707 0 0 1 0-5.217l2.593-2.609 5.185 5.217zm7.215-7.26l-5.185-5.217 5.185-5.217 5.185 5.217zm12.4 7.26a3.653 3.653 0 0 1-5.185 0l-2.592-2.609 5.185-5.217 2.592 2.609a3.707 3.707 0 0 1 .008 5.216zm-2.592-17.13L108.02 30l5.185-5.217L118.389 30zm22.885-1.972a2.951 2.951 0 0 1-1.628-.392L129.551 30l4.917-2.856A3.382 3.382 0 0 1 139.359 30a3.4 3.4 0 0 1-3.27 3.244z"
						transform="translate(-60.897)"
					/>
				</svg>
			);
			break;
		case "blue_knot":
			returnSvg = (
				<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox={"0 0 " + props.width + " " + props.height}>
					<defs>
						<linearGradient id="ux5ct9671a" x1=".5" x2=".5" y1="1" gradientUnits="objectBoundingBox">
							<stop offset="0" stopColor="#0048ba" />
							<stop offset="1" stopColor="#2f7fff" />
						</linearGradient>
					</defs>
					<g>
						<g>
							<g>
								<path
									fill="url(#ux5ct9671a)"
									d="M161.743 26.841a13.117 13.117 0 0 0-6.568 1.756l-10.25 5.921-7.674-7.677 3.477-3.478A13.688 13.688 0 1 0 121.374 4L117.9 7.481 114.42 4a13.688 13.688 0 0 0-19.354 19.36l3.477 3.478-7.674 7.677L80.628 28.6a13.158 13.158 0 1 0-.008 22.8l10.249-5.92 7.674 7.677-3.477 3.478A13.688 13.688 0 0 0 114.42 76l3.477-3.478L121.374 76a13.688 13.688 0 1 0 19.354-19.36l-3.477-3.478 7.674-7.677 10.241 5.915a13.158 13.158 0 1 0 6.577-24.556zM76.226 43.807a3.906 3.906 0 0 1-2.159.511 4.57 4.57 0 0 1-4.4-4.318 4.385 4.385 0 0 1 6.568-3.8L82.82 40zm51.348-33.6a4.918 4.918 0 1 1 6.954 6.956l-3.477 3.478-6.951-6.958zm-9.677 9.68l6.954 6.956L117.9 33.8l-6.954-6.956zM101.266 10.2a4.919 4.919 0 0 1 6.954 0l3.477 3.478-6.954 6.956-3.477-3.478a4.922 4.922 0 0 1 0-6.956zM97.789 40l6.954-6.956L111.7 40l-6.954 6.956zm10.431 29.793a4.918 4.918 0 0 1-6.954-6.956l3.477-3.478 6.954 6.956zm9.677-9.68l-6.954-6.956L117.9 46.2l6.954 6.956zm16.631 9.68a4.919 4.919 0 0 1-6.954 0l-3.474-3.478 6.954-6.956 3.477 3.478a4.923 4.923 0 0 1-.003 6.956zm-3.477-22.838L124.1 40l6.954-6.956L138 40zm30.692-2.629a3.976 3.976 0 0 1-2.184-.523L152.974 40l6.594-3.808a4.537 4.537 0 0 1 6.56 3.808 4.546 4.546 0 0 1-4.385 4.325z"
									transform="translate(-60.897) translate(60.897) translate(-60.897)"
								/>
							</g>
						</g>
					</g>
				</svg>
			);

			break;
		default:
			returnSvg = <>No Icon</>;
			break;
	}
	return returnSvg;
}
